import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Article } from '../../model/article';
import { Menu } from '../../model/menu';


@Injectable()
export class MenuService {

  /* articles: Article[]; */

  iSconnecting: boolean = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
  ) { }


  getAllMenuProvider(){
    
    return this.http.get<Menu[]>(this.apiEndpoints.URL_GET_MENU, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }

  updateMenuProvider(id,contenu?, name?){

    const body=  {
      
    items:JSON.stringify(contenu)
               
    };
  
    // var donnees = JSON.stringify(body);

    return this.http.patch(this.apiEndpoints.GET_URL_PUT_MENU(id), body, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  
  }

  createMenuProvider(nm){

    const body=  {
      nom: nm,
     
               
     };
     
     var donnees = JSON.stringify(body);
     
     return this.http.post(this.apiEndpoints.GET_URL_POST_MENU, donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
    
   }


   deleteMenuProvider(id){

     return this.http.delete(this.apiEndpoints.GET_URL_DELETE_MENU(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

   }

  
  getOneMenuProvider(id){

    return this.http.get(this.apiEndpoints.URL_GET_MENUBYID(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }


  /* deleteMenuProvider(id){

    return this.http.delete(this.apiEndpoints.GET_URL_DELETE_ARTICLE(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }

  getMenuProvider(){
   return this.http.get<Article[]>(this.apiEndpoints.URL_GET_ARTICLE, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  }

  getOneMenuProvider(id){
   return this.http.get(this.apiEndpoints.URL_GET_ARTICLEBYID(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  }

  addMenuProvider(art: Article){

      let id_cat: number[];
      id_cat = [];

      if ( art.categories !== undefined && art.categories !== null) {
        for ( let i = 0; i < art.categories.length; i++) {
          id_cat.push(art.categories[i].id);
        }
      }

      const body=  {
        titre: art.titre,
        description: art.description,
        slug: art.slug,
        isPublish: art.is_publish,
        datePublish: art.date_publish,
        photoSelected: art.photo,
        categories: id_cat,
                
      };
    
     var donnees = JSON.stringify(body);
     console.log(donnees);
     return this.http.post(this.apiEndpoints.GET_URL_POST_ARTICLE, donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
   
   }




   updateMenuProvider(art: Article){

    let id_cat: number[];
    id_cat = [];

    if ( art.categories !== undefined && art.categories !== null) {
      for ( let i = 0; i < art.categories.length; i++) {
        id_cat.push(art.categories[i].id);
      }
    }

    const body=  {

      titre: art.titre,
      description: art.description,
      slug: art.slug,
      isPublish: art.is_publish,
      datePublish: art.date_publish,
      photoSelected: art.photo,
      categories: id_cat,

     };

     var donnees = JSON.stringify(body);
     return this.http.patch(this.apiEndpoints.GET_URL_PUT_ARTICLE(art.id), donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

    } */


}
